import { render } from "./PriceSection.vue?vue&type=template&id=527c06b0&scoped=true"
import script from "./PriceSection.vue?vue&type=script&lang=js"
export * from "./PriceSection.vue?vue&type=script&lang=js"

import "./PriceSection.vue?vue&type=style&index=0&id=527c06b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527c06b0"]])

export default __exports__